import React, { useCallback, useState } from 'react';
import { VendorCTAType } from '../../redux/vendorCTAsReducer';
import { VendorGroupContainer, ContactFormPlaceholder } from './VendorCTAsGroup.style';
import VendorCtaSelector from '../VendorCtaSelector/VendorCtaSelector';
import { FilteredVehicle } from '../../types';
import Modal from '../Modal';

interface VendorCTAsProps {
  ctas: VendorCTAType[];
  vin: string;
  vehicleId: string;
  market: string;
  mainDealer?: string;
  vehicleType: string;
  vehicleData: FilteredVehicle;
}

const VendorCTAsGroup: React.FC<VendorCTAsProps> = ({
  ctas,
  vin,
  vehicleId,
  market,
  mainDealer,
  vehicleType,
  vehicleData,
}) => {
  const {
    bodyType,
    modelMake,
    modelMileage,
    modelCode,
    modelID,
    trimName,
    modelYear,
    modelName,
    modelPrice,
    modelPriceRetail,
    stockNumber,
    fuelType,
  } = vehicleData;

  // no endpoint for family available, so temp solution is to manipulate string
  const removeYearAndMakeFromModelName = (name: string) => {
    const modelNameArray = name.split(' ');
    // remove first two positions - usually year and make
    const [, , ...shortenedModelName] = modelNameArray;
    return shortenedModelName.join(' ');
  };

  const dataModelName =
    vehicleType === 'new' ? removeYearAndMakeFromModelName(modelName) : modelName;

  const [contactModalOpen, setContactModalOpen] = useState<boolean>(false);

  const onContactModalOpen = useCallback((e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setContactModalOpen(true);
  }, []);

  const onContactModalClose = useCallback(() => {
    setContactModalOpen(false);
  }, []);

  return (
    <>
      <VendorGroupContainer>
        {ctas?.length > 0 &&
          ctas.map((cta: VendorCTAType, index) => {
            const buttonVariant = index === 0 ? 'primary' : 'secondary';

            return (
              <VendorCtaSelector
                ctaDetails={cta}
                variant={buttonVariant}
                vin={vin}
                onContactModalOpen={onContactModalOpen}
                vehicleId={vehicleId}
                vehicleType={vehicleType}
                market={market}
                mainDealer={mainDealer}
              />
            );
          })}
        <div
          className="vendorIntegrations_vehicleInfo"
          data-body={bodyType || 'null'}
          data-make={modelMake || 'null'}
          data-mileage={modelMileage || 'null'}
          data-model-code={modelCode || 'null'}
          data-model-number={modelID || 'null'}
          data-model={dataModelName || 'null'}
          data-vin={vin || 'null'}
          data-purchase-price={modelPriceRetail || 'null'}
          data-msrp={modelPrice || '0'}
          data-stock={stockNumber || 'null'}
          data-trim={trimName || 'null'}
          data-type={vehicleType || 'null'}
          data-fuel-type={fuelType || 'null'} // endpoint data not avail from query used
          data-year={modelYear || 'null'}
        />
      </VendorGroupContainer>
      <Modal isOpen={contactModalOpen} onClose={onContactModalClose} data-cy="contact-dealer-modal">
        <ContactFormPlaceholder>[LOAD CONTACT FORM FOR DEALER]</ContactFormPlaceholder>
      </Modal>
    </>
  );
};

export default VendorCTAsGroup;
